import React from 'react';

import { AclExplanationKind, ACL_EXPLANATION_COPY } from './copy';

interface AclStateExplanationProps {
  kind: AclExplanationKind;
  id: string;
}

const buttonStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 22,
  height: 22,
  borderRadius: 6,
  border: '1px solid #64748b',
  background: '#111827',
  color: '#e5e7eb',
  fontSize: 12,
  fontWeight: 800,
  cursor: 'help',
};

const descriptionStyle: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
};

export function AclStateExplanation({ kind, id }: AclStateExplanationProps) {
  const copy = ACL_EXPLANATION_COPY[kind];
  const descriptionId = `${id}-description`;

  return (
    <span>
      <button
        type="button"
        aria-label={copy.buttonLabel}
        aria-describedby={descriptionId}
        data-acl-explanation-control={kind}
        style={buttonStyle}
      >
        ?
      </button>
      <span id={descriptionId} data-acl-explanation-copy={kind} style={descriptionStyle}>
        {copy.label}: {copy.description}
      </span>
    </span>
  );
}

